import React from 'react'
import { observer } from 'mobx-react'
import { WorkspaceInvitationModalViewModel } from '../../WorkspaceInvitationModalViewModel'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooterSection,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
  ModalSheetFooter,
  ModalSheetContentBox,
} from '../../../../components/ModalSheet'
import styles from './WorkspaceInvitationModal.sass'
import Button from '../../../../components/Button'
import Icon from '../../../../components/Icon'
import { formattedTimeUntil } from '../../../../utils/date-util'
import { Congrats } from '../../../components/Congrats'

interface Props {
  vm: WorkspaceInvitationModalViewModel
}

export default observer(function WorkspaceInvitationModal({ vm }: Props) {
  return (
    <ModalSheet
      showing={vm.showing}
      disableCloseOnEsc
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader />
      <ModalSheetContent leftAligned>
        <ModalSheetContentBlock>
          <Congrats />
          <ModalSheetContentTitle>
            You're invited to join a Workspace
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            To claim, review the outsourcing opportunity below.
          </ModalSheetContentDescription>
          <ModalSheetContentBox
            data-test={`invitation-modal-${vm.id}`}
            color="green"
          >
            <span
              className={styles.software}
              data-test={`invitation-modal-software-${vm.id}`}
            >
              {vm.software}
            </span>
            <div className={styles.location}>
              <p>{vm.location}</p>
            </div>
            <div className={styles.specs}>
              <p>{vm.specs.join(' • ')}</p>
            </div>
            <p className={styles.description}>{vm.description}</p>
            <div className={styles.offerAction}>
              <Button
                onClick={vm.accept}
                loading={vm.accept.pending}
                block
                dataTest={`invitation-modal-accept-button-${vm.id}`}
                type="success"
                size="cta"
              >
                Accept Opportunity
              </Button>
            </div>
          </ModalSheetContentBox>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSection>
          <div className={styles.countdownDisplay}>
            <Icon className={styles.clock} name="clock" auto />
            Auto-rejecting in{' '}
            <span className={styles.countdown}>
              {formattedTimeUntil(vm.timeUntilExpiration!)}
            </span>
          </div>
        </ModalSheetFooterSection>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            onClick={vm.reject}
            loading={vm.reject.pending}
            dataTest={`reject-modal-reject-button-${vm.id}`}
          >
            Decline Opportunity
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
